export default {"src":"/_next/static/media/0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};